import * as React from 'react';
import { IGetVillageListResponseSchema } from '../../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';

import { ROAD_DISTANCES } from '../../../interfaces/filters';
import { getRoadDistanceLabel } from '../../../utils/filters_helpers';
import { RoadsSearch } from '../search';
import { trackRoadDistanceChanged, trackRoadsPopupOpened } from '../tracking';
import { TRoadsHeaderProps } from './container';
import { pick } from '../../../utils/pick';

import * as styles from './RoadsHeader.css';
import { Select } from '../../Select';

export class RoadsHeader extends React.PureComponent<TRoadsHeaderProps> {
  public componentDidMount() {
    trackRoadsPopupOpened();
    this.props.filterRoads('');
  }

  public componentWillUnmount() {
    this.props.filterRoads('');
  }

  public render() {
    const { roads, filterRoads, onSelectRoad } = this.props;
    const { roadDistance } = roads;

    const options = ROAD_DISTANCES.map(distance => {
      return {
        label: `${distance} км`,
        value: distance,
        disabled: this.isDistanceDisabled(distance),
      };
    });

    return (
      <div className={styles['container']}>
        <RoadsSearch
          roads={roads}
          onInputChange={(value, trackNotFound) => filterRoads(value, roadDistance, trackNotFound)}
          onSelectRoad={onSelectRoad}
        />
        <Select
          withArrow
          options={options}
          value={roadDistance}
          onChange={this.onDistanceChange}
          text={getRoadDistanceLabel(roadDistance)}
          disabled={ROAD_DISTANCES.every(this.isDistanceDisabled)}
          buttonParams={{ fontWeight: 'normal', fullWidth: true }}
        />
      </div>
    );
  }

  private isDistanceDisabled = (value: number) =>
    this.roadsData && !Object.values(this.roadsData).some((x: number) => x <= value);

  private get roadsData(): IGetVillageListResponseSchema['roadData'] {
    const {
      roads: { selectedRoads },
      roadData,
    } = this.props;

    return selectedRoads.length && roadData ? pick(roadData, selectedRoads) : roadData;
  }

  private onDistanceChange = (roadDistance: number) => {
    trackRoadDistanceChanged();
    this.props.onChangePopupRoadDistance(roadDistance);
  };
}
